export default "__VITE_ASSET__D7pqMxJ2__"